import { useAuth } from '../hooks/useAuth';
import { useSafeRedirect } from './useSafeRedirect';
import PageLoader from '../components/loaders/PageLoader';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, hasPermission, loading } = useAuth();

  useSafeRedirect('/login', !loading && (!isAuthenticated || !hasPermission('view')));

  if (loading) {
    return <PageLoader />;
  }

  if (!isAuthenticated || !hasPermission('view')) {
    return null;
  }

  return children;
}
